import { OnChangeParams } from 'baseui/select';
import { supportedEmbeddingAttributeIndexTypes } from '@tigergraph/tools-models';
import { AttributeSelect } from '@/components/schemaDesigner/attributeEditorContainer/attributeEditor/AttributeSelect';

export interface EmbeddingAttributeIndexTypeSelectProps {
  indexType: string;
  readOnly?: boolean;
  onChange: (indexType: string) => void;
}

export default function EmbeddingAttributeIndexTypeSelect({
  indexType,
  readOnly,
  onChange,
}: EmbeddingAttributeIndexTypeSelectProps) {
  const options = supportedEmbeddingAttributeIndexTypes.map((type) => ({ id: type, label: type }));

  const handleChange = ({ value }: OnChangeParams) => {
    if (value.length > 0) {
      const newIndexType = value[0].id as string;
      onChange(newIndexType);
    }
  };

  return (
    <AttributeSelect
      disabled={readOnly}
      options={options}
      value={[{ id: indexType, label: indexType }]}
      onChange={handleChange}
      placeholder="Select index type"
    />
  );
}
